import { render, staticRenderFns } from "./SetExchange.vue?vue&type=template&id=5c69757f&"
import script from "./SetExchange.vue?vue&type=script&lang=js&"
export * from "./SetExchange.vue?vue&type=script&lang=js&"
import style0 from "./SetExchange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports